export default "__VITE_ASSET__BQSoIUqC__"